import { render } from "./CardPackage.vue?vue&type=template&id=fc960dd0&scoped=true"
import script from "./CardPackage.vue?vue&type=script&lang=js"
export * from "./CardPackage.vue?vue&type=script&lang=js"

import "./CardPackage.vue?vue&type=style&index=0&id=fc960dd0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc960dd0"]])

export default __exports__